// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import SignedState from "./SignedState";

@jsonObject
export default class RecoverFunds extends PerunMessage {
  @jsonMember(SignedState) signedState: SignedState;
  // The hub's stable L1 ETH address. The signed state only carries the hub's
  // per-session key, which the backend cannot resolve after a restart.
  @jsonMember(String) hubAddress: string;

  constructor(signedState: SignedState, hubAddress = "") {
    super();
    this.signedState = signedState;
    this.hubAddress = hubAddress;
  }

  messageType(): MessageType {
    return RecoverFunds;
  }

  messageTypeName(): MessageTypeName {
    return "RecoverFunds";
  }
}
